import React from 'react';

import cx from 'classnames';

import Button from 'components/shared/Button';

import s from './index.module.css';

function BuilderFooterButton(props: React.ComponentProps<typeof Button>) {
  const className = cx(s.buildFooterButton, props.className);

  return (
    <Button htmlType="button" size="medium" {...props} className={className}>
      {props.children}
    </Button>
  );
}

export { BuilderFooterButton };
